import { appsClientHeaders } from "./appsClient.js";
import { API_BASE_URL } from "./config.js";
import { exportPrivateKeyJwk, exportPublicKeyPem, generateEd25519KeyPair, } from "./crypto.js";
export async function pairDevice(code, storage) {
    const normalized = code.trim().toUpperCase();
    if (normalized.length !== 6) {
        throw new Error("Pairing code must be 6 characters");
    }
    const keyPair = await generateEd25519KeyPair();
    const publicKeyPem = await exportPublicKeyPem(keyPair.publicKey);
    const privateKeyJwk = await exportPrivateKeyJwk(keyPair.privateKey);
    const response = await fetch(`${API_BASE_URL}/api/v1/pair`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            ...appsClientHeaders(),
        },
        body: JSON.stringify({
            code: normalized,
            public_key: publicKeyPem,
        }),
    });
    if (!response.ok) {
        const detail = await response.text();
        throw new Error(detail || `Pairing failed (${response.status})`);
    }
    const data = (await response.json());
    const mailServerType = data.mail_server_type === "kerio" ? "kerio" : "dovecot";
    const credentials = {
        deviceId: data.device_id,
        privateKeyJwk,
        imapAccount: data.imap_account,
        mailServerType,
        mailServerHost: data.mail_server_host ?? undefined,
    };
    if (mailServerType === "kerio" && data.mailbox_password) {
        credentials.mailboxPassword = data.mailbox_password;
    }
    await storage.setCredentials(credentials);
    await storage.setActiveAccount(credentials.imapAccount);
    return credentials;
}
